import { HFlow, InfoLabel, Tag, Text, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { useLoadAntecedentesQuery } from 'graphql/hooks.generated'
import React from 'react'
import { formatDate } from 'util/date/formatDate'

import { AcompanhamentoCard } from '../../components/AcompanhamentoCard'

interface AntecedentesObstetricosCardProps {
  prontuarioId: ID
}

export function AntecedentesObstetricosCard(props: AntecedentesObstetricosCardProps) {
  const { prontuarioId } = props

  const {
    data: { antecedente },
    loading,
  } = useLoadAntecedentesQuery({
    variables: {
      id: prontuarioId,
    },
    fetchPolicy: 'cache-first',
  })

  const dataUltimaAtualizacao = antecedente?.dataUltimaAtualizacaoGestacional

  return (
    <AcompanhamentoCard
      id='antecedentes-obstetricos'
      title='Antecedentes obstétricos'
      loading={loading}
      placeholder='Nenhum antecedente registrado'
      headerContent={
        dataUltimaAtualizacao && (
          <Tag icon='redo' type='normal'>
            <HLabel title='Última atualização'>
              <Text fontWeight='normal'>- {formatDate(dataUltimaAtualizacao)}</Text>
            </HLabel>
          </Tag>
        )
      }
    >
      {antecedente && dataUltimaAtualizacao && (
        <HFlow justifyContent='space-between'>
          <VFlow>
            <HFlow>
              <InfoLabel title='Gestas prévias'>{antecedente.gestacoesPrevias}</InfoLabel>
              <InfoLabel title='Abortos'>{antecedente.qtAbortos}</InfoLabel>
            </HFlow>
            {antecedente.partoMenosDeUmAno && (
              <Text fontStyle='italic'>(Desfecho da última gestação aconteceu há menos de 1 ano)</Text>
            )}
          </VFlow>
          <InfoLabel title='Partos'>
            <VFlow vSpacing={0}>
              <HLabel title='Partos realizados:' titleFontWeight='normal'>
                {antecedente.qtPartos}
              </HLabel>
              <HLabel title='Vaginais:' titleFontWeight='normal'>
                {antecedente.partosVaginais}
              </HLabel>
              <HLabel title='Cesáreas:' titleFontWeight='normal'>
                {antecedente.qtCesareas}
              </HLabel>
              <HLabel title='Partos domiciliares:' titleFontWeight='normal'>
                {antecedente.partosDomiciliares}
              </HLabel>
            </VFlow>
          </InfoLabel>
          <InfoLabel title='Nascidos'>
            <VFlow vSpacing={0}>
              <HLabel title='Vivos:' titleFontWeight='normal'>
                {antecedente.nascidosVivos}
              </HLabel>
              <HLabel title='Mortos:' titleFontWeight='normal'>
                {antecedente.natimortos}
              </HLabel>
            </VFlow>
          </InfoLabel>
          <InfoLabel title='Recém-nascidos com'>
            <VFlow vSpacing={0}>
              <HLabel title='Menos de 2500g:' titleFontWeight='normal'>
                {antecedente.recemNascidosAbaixo}
              </HLabel>
              <HLabel title='Mais de 4500g:' titleFontWeight='normal'>
                {antecedente.recemNascidosAcima}
              </HLabel>
            </VFlow>
          </InfoLabel>
          <InfoLabel title='Nascidos vivos'>
            <VFlow vSpacing={0}>
              <HLabel title='Vivem:' titleFontWeight='normal'>
                {antecedente.filhosVivos}
              </HLabel>
              <HLabel title='Mortos na 1ª semana:' titleFontWeight='normal'>
                {antecedente.obitoAntesPrimeiraSemana}
              </HLabel>
              <HLabel title='Mortos depois da 1ª semana:' titleFontWeight='normal'>
                {antecedente.obitoAposPrimeiraSemana}
              </HLabel>
            </VFlow>
          </InfoLabel>
        </HFlow>
      )}
    </AcompanhamentoCard>
  )
}
